import React, {Fragment} from "react";
import CustomList_Delete from "./CustomList_Delete";
import CustomListField from "./CustomListField";

const CustomList_7cells = ({rowKey, config, last = false}) => {

    const columnName = index => `${config.namePrefix}${config.columns[index].namePrefix}${rowKey}`;
    const columnLabel = index => config.columns[index].label;
    const columnPlaceholder = index => config.columns[index].placeholder ?? config.placeholder;
    const columnRequired = index => config.columns[index].required ?? true;

    const renderCell = (index, withBorderLeft = false) => (
        <div className={`col-12 col-lg-6 px-3 py-2 ${withBorderLeft ? 'border-left' : ''}`} key={index}>
            <label htmlFor={columnName(index)} className="m-lg-0">
                {columnLabel(index)}{columnRequired(index) && <sup>*</sup>}
            </label>
            <CustomListField name={columnName(index)} placeholder={columnPlaceholder(index)}/>
        </div>
    );

    const renderRow = (leftIdx, rightIdx, isFirst = false) => (
        <div className={`row no-gutters ${isFirst ? '' : 'border-top'}`} key={`r${leftIdx}`}>
            {renderCell(leftIdx)}
            {rightIdx !== null
                ? renderCell(rightIdx, true)
                : (
                    <div className="col-12 col-lg-6 px-3 py-2 border-left d-flex align-items-end justify-content-end">
                        <CustomList_Delete config={config} rowKey={rowKey}/>
                    </div>
                )
            }
        </div>
    );

    return (
        <Fragment key={rowKey}>
            <div className={`col-12 ${last ? '' : 'custom-list-block'}`}>
                {renderRow(0, 1, true)}
                {renderRow(2, 3)}
                {renderRow(4, 5)}
                {renderRow(6, null)}
            </div>
        </Fragment>
    );
};

export default CustomList_7cells;
